(function() {
    const textPageEl = document.querySelector('.jsTextPage');

    if (textPageEl) {
        const anchorListEl = textPageEl.querySelector('.jsAnchorList');

        if (anchorListEl) {
            const sectionElsWrapperEl = textPageEl.querySelector('.jsAnchorList');
            const sectionEls = textPageEl.querySelectorAll('[data-anchor]');

            window.addEventListener('scroll', _ => setActiveSection());

            sectionElsWrapperEl.addEventListener('click', e => {
                if (e.target.classList.contains('jsAnchorTrigger')) {
                    const section = textPageEl.querySelector('[data-anchor="' + e.target.dataset.anchorSlug + '"]');
                    vanillaSmoothie.scrollTo(section.getBoundingClientRect().y + window.scrollY - 50, { duration: 500, easing: 'easeInOutQuad' });
                }
            });

            setActiveSection();

            function setActiveSection() {
                const triggerPoint = window.scrollY + (window.innerHeight * 0.2);

                for (let i = 0; i < sectionEls.length; i++) {
                    const section = sectionEls[i];
                    const bounds = section.getBoundingClientRect();
                    const sectionTrigger = textPageEl.querySelector('[data-anchor-slug="' + section.dataset.anchor + '"]');

                    if (bounds.y + window.scrollY <= triggerPoint && bounds.y + window.scrollY + bounds.height >= triggerPoint) sectionTrigger.classList.add('active');
                    else sectionTrigger.classList.remove('active');
                }
            };
        }
    }
})();
